/**
 * Sample rate BPS for showing the Qualtrics CSAT survey to retailers
 */
export const QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS = 'QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS';
